// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__2jLZj","left":"InfoRow_left__2Sivj"};